(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-the-look"] && !Shopify.designMode) return;
  try {
    (function () {
    function cartSectionIds() {
      var el = document.querySelector('cart-drawer');
      var ids = [];
      if (el) {
        if (Array.isArray(el.sectionsToRender)) {
          el.sectionsToRender.forEach(function (s) { if (s && s.id) ids.push(s.id); });
        }
        if (!ids.length && el.sectionId) ids.push(el.sectionId);
        var attr = el.getAttribute('section-id');
        if (attr && ids.indexOf(attr) === -1) ids.push(attr);
      }
      if (ids.indexOf('cart-json') === -1) ids.push('cart-json');
      return ids;
    }

        function swapSections(sections) {
      if (!sections) return;

      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');

        var freshItems = parsed.querySelector('cart-drawer-items');
        var liveItems = document.querySelector('cart-drawer-items');
        if (freshItems && liveItems) {
          liveItems.innerHTML = freshItems.innerHTML;
          liveItems.setAttribute('data-count', freshItems.getAttribute('data-count') || '');
        }

        var freshFooter = parsed.querySelector('.hdt-drawer__footer, [class*="drawer__footer"]');
        var liveFooter = document.querySelector('.hdt-drawer__footer, [class*="drawer__footer"]');
        if (freshFooter && liveFooter) {
          liveFooter.innerHTML = freshFooter.innerHTML;
        }

        var freshCount = parsed.querySelector('hdt-cart-count');
        var liveCount = document.querySelector('hdt-cart-count');
        if (freshCount && liveCount) {
          liveCount.innerHTML = freshCount.innerHTML;
          liveCount.setAttribute('data-count', freshCount.getAttribute('data-count') || '');
        }
      });
    }

    function openCartDrawer() {
      var opener = document.querySelector('[aria-controls="CartDrawer"]:not(.hdt-close-dialog-btn)');
      if (opener) { opener.click(); return true; }

      var dialog = document.getElementById('CartDrawer');
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        try { dialog.showModal(); return true; } catch (e) {}
      }
      return false;
    }

    function init(root) {
      if (root.dataset.ctlReady) return;
      root.dataset.ctlReady = '1';

      root.querySelectorAll('select[data-ctl-variant]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var opt = sel.options[sel.selectedIndex];
          if (!opt) return;
          var row = sel.closest('.ctl__row');

          var priceEl = row.querySelector('[data-ctl-price]');
          if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

          var imgEl = row.querySelector('[data-ctl-img]');
          if (imgEl && opt.dataset.image && imgEl.src !== opt.dataset.image) {
            imgEl.style.opacity = '0';
            var next = new Image();
            next.onload = function () {
              imgEl.src = opt.dataset.image;
              imgEl.removeAttribute('srcset');
              imgEl.style.opacity = '1';
            };
            next.onerror = function () { imgEl.style.opacity = '1'; };
            next.src = opt.dataset.image;
          }
        });
      });

      root.querySelectorAll('[data-ctl-add]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var row = btn.closest('.ctl__row');
          var input = row.querySelector('[data-ctl-variant]');
          if (!input || !input.value) return;

          var original = btn.textContent.trim();
          btn.disabled = true;
          btn.textContent = '…';

          var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(input.value), quantity: 1 }],
              sections: cartSectionIds().join(','),
              sections_url: window.location.pathname
            })
          })
            .then(function (r) {
              if (!r.ok) throw new Error();
              return r.json();
            })
            .then(function (data) {
              btn.textContent = 'Added';

              swapSections(data && data.sections);

              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

              setTimeout(openCartDrawer, 100);

              setTimeout(function () {
                btn.textContent = original;
                btn.disabled = false;
              }, 1800);
            })
            .catch(function () {
              btn.textContent = 'Retry';
              btn.disabled = false;
              setTimeout(function () { btn.textContent = original; }, 1800);
            });
        });
      });
    }

    function run() {
      document.querySelectorAll('.ctl').forEach(init);
    }

    run();
    document.addEventListener('shopify:block:select', run);
    document.addEventListener('shopify:section:load', run);
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
